import type { SearchParams } from '@/server/searchParams.ts';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

export const getSearchParamsClient = (searchParamsServer: SearchParams): SearchParams => {
  const searchParams = getSearchParams();
  return Object.keys(searchParams).length === 0 ? searchParamsServer : searchParams;
};

type GetSearchParams = {
  exclude: string[];
};
const getSearchParams = ({ exclude }: GetSearchParams = { exclude: [] }): SearchParams => {
  const searchParamsObj: SearchParams = {};
  if (canUseDOM) {
    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (exclude.indexOf(key) === -1) {
        searchParamsObj[key] = value;
      }
    });
  }

  return searchParamsObj;
};

export default getSearchParams;
